import { useQuery } from "@tanstack/react-query";
import { stageGateApi } from "../../stageGates/api/service";
import { ChangeEvent, useState } from "react";
import { useUpdateChecklists } from "../../stageGates/mutation";

export const useFetchTask = ({
    projectId,
    object_type,
    object_id,
    my_tasks,
    actionTypeFilter,
    priorityFilter,
    statusFilter,
    ownerFilter
}: {
    projectId?: string | undefined;
    object_type: string[] | null;
    object_id: number | null;
    my_tasks: boolean;
    actionTypeFilter?: string[];
    priorityFilter?: string[];
    statusFilter?: string[];
    ownerFilter?: string[];
}) => {
    const updateCheckList = useUpdateChecklists();

    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(25);

    const [searchDraft, setSearchDraft] = useState<string>('');
    const [search_term, setSearchKey] = useState<string>('');

    const { data, isFetching, isPending, isLoading, isError, isRefetching, refetch } = useQuery({
        queryKey: ["tasks", projectId, object_type, object_id, my_tasks, priorityFilter, statusFilter, actionTypeFilter, ownerFilter, search_term, page, limit],
        queryFn: () => stageGateApi.fetchCheckLists({ projectId, search_term, object_type, object_id, my_tasks, page, limit, priorityFilter, statusFilter, actionTypeFilter, ownerFilter }),
    });

    const changePage = (page: number) => {
        setPage(page);
    };

    const changeRowsPerPage = (limit: number) => {
        setLimit(limit);
        setPage(1);
    };

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchDraft(e.target.value);
    };

    const handleClear = () => {
        setSearchDraft('');
        setSearchKey('');
    };

    const handleSearch = () => {
        setSearchKey(searchDraft);
        setPage(1);
    };

    const switchStatus = async (checkListID: string, status: string) => {
        const payload = {
            status: status,
            object_type: 'task',
            object_id: Number(checkListID)
        };
        await updateCheckList.mutateAsync({ checkListID, payload });
    };

    return {
        taskData: data?.data?.rows || [],
        pagination: data?.data?.pagination,
        isPending: isPending || isLoading,
        isRefetching,
        isFetching,
        isError,
        changePage, changeRowsPerPage,
        searchDraft, handleChangeSearch, handleClear, handleSearch,
        refetch, switchStatus
    }

};